import type { Member } from "@/lib/schemas";

/**
 * Etykieta relacji do pokazania zamiast surowego role.
 * Preferuje `member.relation` (np. „Babcia", „Tata"), z fallbackiem
 * na generyczny label zależny od role.
 */
export function relationLabel(member: Pick<Member, "role" | "relation"> | undefined | null): string {
  if (!member) return "—";
  if (member.relation && member.relation.trim().length > 0) {
    return member.relation;
  }
  return member.role === "child" ? "Dziecko" : "Dorosły";
}

export function isAdult(role: Member["role"]): boolean {
  return role === "parent";
}

const FEMALE_RELATIONS = new Set([
  "corka",
  "mama",
  "mamusia",
  "babcia",
  "babunia",
  "ciocia",
  "ciotka",
  "siostra",
]);

const MALE_RELATIONS = new Set([
  "syn",
  "tata",
  "tato",
  "tatus",
  "ojciec",
  "dziadek",
  "dziadzius",
  "wujek",
  "wuj",
  "brat",
]);

function normalize(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

/**
 * Wnioskuje płeć z etykiety relacji (np. „Córka" → "f", „Syn" → "m").
 * Zwraca null gdy nie da się rozpoznać — UI powinien mieć neutralny fallback.
 */
export function genderFromRelation(
  relation: string | undefined | null,
): "f" | "m" | null {
  if (!relation) return null;
  const k = normalize(relation);
  if (FEMALE_RELATIONS.has(k)) return "f";
  if (MALE_RELATIONS.has(k)) return "m";
  return null;
}
